export const postMessageTarget = () => {
    if(import.meta.env.MODE === "development") {
        return "*"
    } else {
        return import.meta.env.VITE_BLUEXP_FRONTEND;
    }
}